class CartItemCount extends HTMLElement {
  connectedCallback() {
    this.unsubscribeCartUpdated = subscribe('cart:updated', ({ itemCount }) =>
      this.render(itemCount)
    );
  }

  disconnectedCallback() {
    this.unsubscribeCartUpdated();
  }

  /**
   * Render the cart count from the event payload.
   * @description Previously each instance fetched ?section_id=fetch-cart-item-count and
   * called replaceWith. There are four instances on the page, so a single cart change
   * triggered four identical section renders. The count is already in the payload.
   * @param {number} itemCount - The cart item count.
   */
  render(itemCount) {
    if (typeof itemCount !== 'number') return;

    this.textContent = itemCount;
    this.classList.toggle('hidden', itemCount === 0);
  }
}

customElements.define('cart-item-count', CartItemCount);
